import {SubscriptionMode, SubscriptionType} from '@enums';
import {SUBSCRIPTION_GALLERY_SLOTS} from '../../constants/subscription.constants';

export const SubscriptionIcons: Record<SubscriptionType, string> = {
	[SubscriptionType.Classique]: '',
	[SubscriptionType.Soutient]: 'assets/icons/SLAVEOUS_coffee-cup.svg',
	[SubscriptionType.Premium]: 'assets/icons/SLAVEOUS_PREMIUM.svg',
	[SubscriptionType.Eternal]: 'assets/icons/SLAVEOUS_PREMIUM.svg'
};

export function getMaxGallerySlotsForType(type: SubscriptionType): number {
	return SUBSCRIPTION_GALLERY_SLOTS[type];
}

export interface SubscriptionPrice {
	value: number;
	uuid: string;
}

export class Subscription {
	standard: SubscriptionPrice;
	promo?: SubscriptionPrice;
	type: SubscriptionType;
	mode: SubscriptionMode;
	isPromo: boolean;

	constructor(standard: SubscriptionPrice, type: SubscriptionType, mode: SubscriptionMode, isPromo: boolean, promo?: SubscriptionPrice) {
		this.standard = standard;
		this.promo = promo;
		this.type = type;
		this.mode = mode;
		this.isPromo = isPromo;
	}

	static fromObject(obj: Record<string, unknown>) {
		return Object.assign(new Subscription({
			                                      uuid: '',
			                                      value: 0
		                                      }, SubscriptionType.Classique, SubscriptionMode.payment, false), obj);
	}
}
